import RepurchaseDefinition from '../../shared/partials/repurchase-definition.pt.mdx';

export const title = 'Composição dos pedidos';

Detalhamento dos pedidos feitos pelo app. Aqui você consegue ver:
- Quantos pedidos são de clientes novos;
- Quantos são de clientes que já haviam comprado no seu site antes e fizeram a primeira compra pelo app; e
- Quantos são de clientes que já haviam comprado no app e compraram novamente pelo app.

Quanto maior for a fatia de recompras no app, melhor. Isso significa que seu app está fazendo efeito
e funcionando como ferramenta de fidelização e recompras!
